import React from 'react';
import { ArrowRight, Calendar, BarChart3, Users, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const NextSteps = ({ plan }) => {
  const navigate = useNavigate();

  const steps = [
    {
      icon: Calendar,
      title: 'Start Daily Check-ins',
      description: 'Track your symptoms with unlimited entries',
      action: () => navigate('/daily-check-in'),
      available: true
    },
    {
      icon: BarChart3,
      title: 'Explore Analytics',
      description: 'View advanced insights and pattern analysis',
      action: () => navigate('/caregiver-analytics-dashboard'),
      available: plan?.features?.advanced_analytics
    },
    {
      icon: Users,
      title: 'Add Caregivers',
      description: 'Connect with family members or healthcare providers',
      action: () => navigate('/user-relationship-management'),
      available: plan?.features?.caregiver_management
    },
    {
      icon: FileText,
      title: 'Export Reports',
      description: 'Generate comprehensive summaries for your doctor',
      action: () => navigate('/doctor-summary-export'),
      available: true
    }
  ];

  const availableSteps = steps?.filter(s => s?.available);

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Next Steps</h2>
      <p className="text-gray-600 mb-6">
        Get the most out of your {plan?.name} subscription with these features:
      </p>
      <div className="space-y-3">
        {availableSteps?.map((step, index) => {
          const IconComponent = step?.icon;
          return (
            <button
              key={index}
              onClick={step?.action}
              className="w-full flex items-center p-4 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-lg transition-colors text-left group"
            >
              <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                <IconComponent className="w-5 h-5 text-blue-600" />
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-semibold text-gray-900 mb-1">{step?.title}</h3>
                <p className="text-xs text-gray-600">{step?.description}</p>
              </div>
              <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors flex-shrink-0" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default NextSteps;